import * as React from 'react';
import { FormSelect } from 'source/app/presentation/Shared/Form/Select/FormSelect';
import Render from 'source/app/presentation/Shared/Render';
import RPGIcon, {
	GetRPGIcon,
	GetRPGIconNames
} from 'source/app/presentation/Shared/RPGIcon/RPGIcon';
import { RPGIconSelector } from 'source/app/presentation/Shared/RPGIcon/RPGIconSelector/RPGIconSelector';
import GoalEditorPanel from '../GoalEditorPanel';
import { HandleValueChange } from '../HandleValueChange';

export function GEPGoalIcon({
	iconName,
	style,
	onChange,
	canSave,
	GEP
}: {
	iconName: string;
	style: string;
	onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
	canSave: boolean;
	GEP: GoalEditorPanel;
}) {
	return (
		<div>
			<FormSelect
				id="goalIcon"
				label="icon"
				width="140px"
				suggestions={GetRPGIconNames()}
				onChange={onChange}
				value={iconName}
				readonly={!canSave}
			/>
			<Render id="goalIcon" when={iconName} withClasses={style}>
				<RPGIcon icon={GetRPGIcon(iconName)} />
			</Render>
			<RPGIconSelector
				OnSelect={(iconName) =>
					HandleValueChange(GEP, iconName, 'icon')}
				currentIconName={iconName}
			/>
		</div>
	);
}
